import React from "react"
import Layout from "../components/Layout"
import "../css/projects/pythonprojectcard.css"
import { Link } from "gatsby"
import Particle7 from "../components/Particle7"
import SEO from "../components/SEO"

const Pythonprojectcard = () => {
    return (
        <Layout>
            <SEO
                title="Python Projects"
                description="This Page is for Python Project Ocean."
            />
            <Particle7></Particle7>
            <h6>s</h6>
            <div className="programming-projectp">
                <h1>Machine Learning Projects</h1>
            </div>

            <div className="favp noSelect">
                <h3>
                    Those projects having a{" "}
                    <span role="img" aria-label="Heart">
                        ❤️
                    </span>{" "}
                    on them... come under the Favourite category.{" "}
                </h3>
            </div>

            <section className="most-likedp noSelect">
                <h3 className="totalp">Total Projects :- 4</h3>
                <div className="rowp">
                    <div className="rotatep">
                        <div className="coffee-cardp">
                            <div className="card-headerp">
                                <h3 className="title-textp">
                                    Salary Prediction
                                    <span role="img" aria-label="Heart">
                                        ❤️
                                    </span>
                                </h3>
                            </div>
                            <div className="ml-img1"></div>
                            <div className="backp">
                                <div className="back-contentp">
                                    <div className="layer"></div>
                                    <h4 className="textp">Checkout here...</h4>
                                    <div className="bttn-boxp">
                                        <a
                                            href="https://github.com/arpitsomani8/Salary-Prediction-Web-App"
                                            className="btnttp"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            Github Code
                                        </a>
                                        <a
                                            href="https://salarypredictby-arpitsomani.herokuapp.com/"
                                            className="btnttp"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            View Live
                                        </a>

                                        <Link to="/ml_proj1/" className="btnttp">
                                            More Detail
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="rotatep">
                        <div className="coffee-cardp">
                            <div className="card-headerp">
                                <h3 className="title-textp">
                                    Car Price Prediction
                                    <span role="img" aria-label="Heart">
                                        ❤️
                                    </span>
                                </h3>
                            </div>
                            <div className="ml-img2"></div>
                            <div className="backp">
                                <div className="back-contentp">
                                    <div className="layer"></div>
                                    <h4 className="textp">Checkout here...</h4>
                                    <div className="bttn-boxp">
                                        <a
                                            href="https://github.com/arpitsomani8/Car-Price-Prediction-Web-App"
                                            className="btnttp"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            Github Code
                                        </a>
                                        <a
                                            href=" https://car-price-prediction-by-arpit.herokuapp.com/"
                                            className="btnttp"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            View Live
                                        </a>

                                        <Link to="/ml_proj2/" className="btnttp">
                                            More Detail
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="rotatep">
                        <div className="coffee-cardp">
                            <div className="card-headerp">
                                <h3 className="title-textp">
                                    Movie Recommendation
                                   
                                </h3>
                            </div>
                            <div className="ml-img3"></div>
                            <div className="backp">
                                <div className="back-contentp">
                                    <div className="layer"></div>
                                    <h4 className="textp">Checkout here...</h4>
                                    <div className="bttn-boxp">
                                        <a
                                            href="https://github.com/arpitsomani8/Movie-Recommendation-Web-App"
                                            className="btnttp"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            Github Code
                                        </a>
                                        <a
                                            href=" https://movie-recommendation-system-ap.herokuapp.com/"
                                            className="btnttp"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            View Live
                                        </a>

                                        <Link to="/ml_proj3/" className="btnttp">
                                            More Detail
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>




                    <div className="rotatep">
                        <div className="coffee-cardp">
                            <div className="card-headerp">
                                <h3 className="title-textp">Diabetes Predictions
                                <span role="img" aria-label="Heart">
                                        ❤️
                                    </span></h3>
                            </div>
                            <div className="ml-img4"></div>
                            <div className="backp">
                                <div className="back-contentp">
                                    <div className="layer"></div>
                                    <h4 className="textp">Checkout here...</h4>
                                    <div className="bttn-boxp">
                                        <a
                                            href="https://github.com/arpitsomani8/Diabetes-Predictions-Web-App"
                                            className="btnttp"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            Github Code
                                        </a>

                                        <Link to="/ml_proj4/" className="btnttp">
                                            More Detail
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </Layout>
    )
}

export default Pythonprojectcard
